import { useTranslation } from 'react-i18next';
import { tss } from 'tss-react';

import { IProps } from 'components/desktop/Recipe/RecipeTabs/Components/RecipeErpViewNew/Detail/Index';
import FormatedDate from 'components/desktop/_general/FormatedDate/FormatedDate';

export const Informations = (props: IProps) => {
	const { t } = useTranslation();
	const { classes } = useStyles();

	return (
		<div className={classes.container}>
			<div>
				{t('_general:CREATION_DATE')}:{' '}
				<FormatedDate date={props.erpRecipe.createdDateUtc} />
			</div>
			<div>
				{t('_general:LAST_CHANGE_DATE')}:{' '}
				<FormatedDate date={props.erpRecipe.lastEditedDateUtc} />
			</div>
		</div>
	);
};

export const useStyles = tss.create({
	container: {
		opacity: '0.3',
	},
});

export default Informations;
